var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconSort = function SvgIconSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.014 2.526c.729 0 1.327.556 1.395 1.267l.007.135v11.984l1.151-1.151c.24-.24.544-.375.857-.404l.134-.007a1.4 1.4 0 0 1 1.088 2.287l-.096.107-3.545 3.544a1.39 1.39 0 0 1-.857.404l-.135.007c-.314 0-.628-.106-.885-.315l-.106-.096-3.544-3.544a1.401 1.401 0 0 1 .857-2.387l.134-.007c.314 0 .628.105.885.315l.106.096 1.152 1.151V3.928c0-.728.556-1.327 1.267-1.395l.135-.007zm-5.91 11.856a2.738 2.738 0 0 0-.291 2.012l.057.205H3.11a1.108 1.108 0 0 1-.122-2.211l.12-.006h7.996zm3.177-4.45v2.218H3.11a1.11 1.11 0 0 1-.122-2.212l.12-.007h11.173zm0-4.449v2.218H3.11a1.11 1.11 0 0 1-.122-2.212l.12-.007h11.173z",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgIconSort;